import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {alertTypes, useAlerts} from '../ui/alert';
import {
  feriadosGetThunk,
  feriadosGetDuck,
  feriadoDeleteDuck,
  feriadoDeleteThunk,
} from './duck';
import {constants, responseSelector} from '../utils/utils';
import {FeriadosListView} from './FeriadosListView';
import {useQueryParams} from '../utils/useQueryParams';


const queryString = require('query-string');

export const FeriadosList = ({history, token}) => {
  const {queryParams, queryParamsloaded} = useQueryParams(history);

  const dispatch = useDispatch();

  const feriadosGet = useSelector(state => state.feriadosGet);

  const feriadoDelete = useSelector(state => state.feriadoDelete);

  const [filters, setFilters] = useState({});
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalResults, setTotalResults] = useState(0);
  const [lista, setLista] = useState(null);
  const [selected, setSelected] = useState();
  const [isDeleteConfirmModalShown, setIsDeleteConfirmModalShown] =
    useState(false);

  const [busquedaRapida, setBusquedaRapida] = useState('');

  const {submitAlert, setTopAlert, topAlert} = useAlerts();

  const _getFiltersFromQueryParams = queryParams => {
    const page = Number(queryParams?.page ?? 1);
    const busquedaRapida = queryParams?.busquedaRapida ?? '';

    return {
      busquedaRapida,
      page,
    };
  };

  const getFeriados = filters => {
    if (!filters) {
      throw new Error('No filters received');
    }

    dispatch(
      feriadosGetThunk({
        userToken: token.raw,
        limit: pageSize,
        page: filters.page,
        busquedaRapida: filters.busquedaRapida,
      }),
    );
  };

  useEffect(() => {
    if (!queryParamsloaded) return;

    const filters = _getFiltersFromQueryParams(queryParams);

    setPage(filters.page);
    setBusquedaRapida(filters.busquedaRapida);

    setFilters(filters);
    getFeriados(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams, queryParamsloaded]);

  useEffect(() => {
    const {data, error, errorMessage} = responseSelector(feriadosGet);

    if (error) {
      setTopAlert({
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      });

      dispatch(feriadosGetDuck.actions.clear());
    }

    if (data) {
      setTotalResults(data.count);
      setLista(data.items);

      dispatch(feriadosGetDuck.actions.clear());
    }
  }, [feriadosGet]);

  useEffect(() => {
    const {httpStatus, error, errorMessage} = responseSelector(feriadoDelete);

    if (error) {
      const errorAlert = {
        text: errorMessage,
        type: alertTypes.danger,
        closable: false,
      };
      setTopAlert(errorAlert);

      setIsDeleteConfirmModalShown(false);

      dispatch(feriadoDeleteDuck.actions.clear());
    }

    if (httpStatus === constants.HTTP_SUCCESS) {
      handlePage(1);

      setTopAlert({
        text: 'Feriado eliminado',
        type: alertTypes.success,
        closable: false,
      });

      setIsDeleteConfirmModalShown(false);
      dispatch(feriadoDeleteDuck.actions.clear());
    }
  }, [feriadoDelete]);

  const handlePage = page => {
    const strNewParams = queryString.stringify({
      page,
      busquedaRapida,
      ts: new Date().getTime(),
    });

    history.replace(`${history.location.pathname}?${strNewParams}`);
  };

  const doDeleteFeriado = () => {
    dispatch(
      feriadoDeleteThunk({
        userToken: token.raw,
        id: selected?._id,
      }),
    );
  };

  return (
    <FeriadosListView
      history={history}
      topAlert={topAlert}
      submitAlert={submitAlert}
      totalResults={totalResults}
      page={page}
      pageSize={pageSize}
      handlePage={handlePage}
      lista={lista}
      busquedaRapida={busquedaRapida}
      setBusquedaRapida={setBusquedaRapida}
      feriadosGet={feriadosGet}
      doDeleteFeriado={doDeleteFeriado}
      feriadoDelete={feriadoDelete}
      selected={selected}
      setSelected={setSelected}
      isDeleteConfirmModalShown={isDeleteConfirmModalShown}
      setIsDeleteConfirmModalShown={setIsDeleteConfirmModalShown}
    />
  );
};
